import { connectFunctionsEmulator, getFunctions, httpsCallable, type Functions } from 'firebase/functions';

import { getFirebaseApp } from './app';
import { getFirebaseEnvConfig } from './config';

type FunctionsGlobalState = typeof globalThis & {
  __verdeconfirmaFunctions?: Functions;
  __verdeconfirmaFunctionsEmulatorConnected?: boolean;
};

const firebaseGlobal = globalThis as FunctionsGlobalState;

export function getFirebaseFunctions(): Functions {
  if (firebaseGlobal.__verdeconfirmaFunctions) {
    return firebaseGlobal.__verdeconfirmaFunctions;
  }

  const config = getFirebaseEnvConfig();
  const functions = getFunctions(getFirebaseApp(), config.functionsRegion);

  if (config.useEmulators && !firebaseGlobal.__verdeconfirmaFunctionsEmulatorConnected) {
    connectFunctionsEmulator(functions, '127.0.0.1', 5001);
    firebaseGlobal.__verdeconfirmaFunctionsEmulatorConnected = true;
  }

  firebaseGlobal.__verdeconfirmaFunctions = functions;
  return functions;
}

export { httpsCallable };
